import makeLuxonDate from '../functions/makeLuxonDate';

const formatDate = (date: string) => {
  const splittedDate = makeLuxonDate(date).split('/');
  const formattedDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`;
  return formattedDate;
};

export default formatDate;
